export type PromoVideoConfig = {
  url: string;
  poster: string;
};

export const EDUCATION_DISCOVERY_PROMO_VIDEO: PromoVideoConfig = {
  url: "https://pub-93afee7b00104ad6a5e2e7390b938f73.r2.dev/promo/find-the-right-fit-nearby.mp4",
  poster: "/assets/img/poster/find_education_provider_post.png",
};
